/*
 * Gets Cloud Server URL by stripping `app.` part from the hostname
 */
export function getCloudServerUrl() {

  const hostAndPort = window.location.host;
  return hostAndPort.split(':')[0];
}

export function getCloudServerPort() {
  return window.location.protocol === 'https:' ? 443 : 8034;
}

export function getCloudServerProtocol() {
  return window.location.protocol.concat('//');
}
